import iconLarge from './assets/images/branding/Sovos-Default-Product-Icon-Large.svg';
import logoLightSvg from './assets/images/branding/Sovos-Logo-White.svg';
import logoDarkSvg from './assets/images/branding/Sovos-Logo.svg';
import heroDarkBgImg from './assets/images/heroBanners/colors/hero-bg-darkBlue.png';
import heroDefaultBgImg from './assets/images/heroBanners/colors/hero-bg-blue.png';
import heroErrorBgImg from './assets/images/heroBanners/colors/hero-bg-red.png';
import heroInProgressBgImg from './assets/images/heroBanners/colors/hero-bg-grayMedium.png';
import heroSuccessBgImg from './assets/images/heroBanners/colors/hero-bg-green.png';
import heroWarningBgImg from './assets/images/heroBanners/colors/hero-bg-yellow.png';
import noDataAvailableSvg from './assets/images/emptyStates/noDataAvailable.svg';
import noSearchResultsSvg from './assets/images/emptyStates/noSearchResults.svg';
import noTasksAvailableSvg from './assets/images/emptyStates/noTasksAvailable.svg';
import assetKeys from './assetKeys';
const enUSCommon = {
  add: "Add",
  apply: "Apply",
  cancel: "Cancel",
  clear: "Clear",
  open: "Open",
  close: "Close",
  "delete": "Delete",
  download: "Download",
  downloadAll: "Download All",
  endDate: "End Date",
  endValue: "End Value",
  more: "More",
  noResults: "No results found",
  reset: "Reset",
  save: "Save",
  search: "Search",
  settings: "Settings",
  showLess: "Show less",
  showMore: "Show more",
  startDate: "Start Date",
  startValue: "Start Value",
  yourAccount: "Your Account",
  actions: {
    audit: "Audit",
    "continue": "Continue",
    clear: "Clear",
    create: "Create",
    edit: "Edit",
    file: "File",
    "import": "Import",
    "new": "New",
    remove: "Remove",
    done: "Done"
  },
  commonWords: {
    assignee: "Assignee",
    company: "Company",
    country: "Country",
    customer: "Customer",
    deadline: "Deadline",
    no: "No",
    only: "Only",
    or: "or",
    "return": "Return",
    required: "Required",
    saved: "Saved",
    task: "Task",
    vendor: "Vendor",
    yes: "Yes"
  },
  friendlyTimestamp: {
    seconds: "s",
    minutes: "m",
    hours: "h",
    day: "d",
    ago: "ago",
    today: "today",
    tomorrow: "tomorrow"
  },
  months: {
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December"
  },
  monthsAbbrev: {
    january: "Jan",
    february: "Feb",
    march: "Mar",
    april: "Apr",
    may: "May",
    june: "Jun",
    july: "Jul",
    august: "Aug",
    september: "Sep",
    october: "Oct",
    november: "Nov",
    december: "Dec"
  }
};
const enUSs1ui = {
  aboutThis: {
    learnMore: "Learn more about",
    privacyPolicy: "Privacy Policy",
    termsAndConditions: "Terms & Conditions",
    version: "Version"
  },
  accountSwitcher: {
    production: "Production",
    test: "Test"
  },
  attachmentsTab: {
    label: "Attachments"
  },
  attachmentsListTab: {
    emptyListLabel: "No attachments yet",
    primaryButtonLabel: "Add Attachment"
  },
  autocomplete: {
    helpMessageTemplate: "characters needed to search",
    loadingMessage: "Searching"
  },
  avatar: {
    noName: "Unassigned"
  },
  commentsTab: {
    label: "Comments"
  },
  closeButton: {
    toolTip: "Close Panel"
  },
  columnDrawer: {
    addTooltipText: "Show Column",
    header: "Drag and drop to modify the order of columns",
    removeTooltipText: "Hide Column",
    removeDisabledTooltipText: "You must display at least 1 column",
    title: "Columns"
  },
  commentForm: {
    attachmentButtonTooltipText: "Add attachment",
    commentPlaceholder: "Begin typing to leave a comment...",
    errorEmpty: "Comment is empty.",
    errorLength: "Comment must be less than 500 characters.",
    submitButton: "Comment"
  },
  commentsListTab: {
    emptyListLabel: "No comments yet...",
    showLessLabel: "Show fewer comments",
    showMoreLabel: "Show more comments",
    tabPropsLabel: "Comments"
  },
  confirmationDialog: {
    defaultTitle: "Are you sure?",
    defaultContent: "A positive confirmation, like Transmit, should have 2 buttons: Cancel (secondary button) and 'Positive action' (primary button). A negative confirmation, like Delete, should have 2 actions, Cancel (primary button) and 'Negative action' in a red button."
  },
  customThemePage: {
    chooseTitle: "Choose your theme",
    clearLogoTooltip: "Clear logo url",
    colorPickerAriaLabel: "Color Picker",
    customizeTitle: "Customize",
    defaultContentText: "Do you want to overwrite the custom theme with the selected colors?",
    defaultLabels: {
      logoDescription: {
        recommended: "Recommended file formats: .svg, .webp, or .png file with a transparent background.",
        note: "Note: The uploaded file will be scaled proportionally to a height of 22 pixels. The new logo will appear immediatly in the navigation.",
        warning: "To use the default SOVOS logo, remove the uploaded file."
      },
      logoAltLabel: "Logo alt text",
      logoAltHelptext: "Alt text for custom logo is required for accessibility",
      chooseTitle: "Choose your theme",
      chooseDescription: "Pick a theme. You can customize it in the next step.",
      customizeTitle: "Customize",
      customizeDescription: "Fine-tune you colour palette.",
      customSubtitles: {
        highlights: "Menu accents and highlights.",
        gradientBottom: "Menu background gradient bottom.",
        gradientTop: "Menu background gradient top.",
        productIconColor: "Product switcher background",
        textColor: "Text appearing in the menu."
      }
    },
    defaultTitleText: "Overwrite Custom Colors",
    logoHelptext: "Protocol and top-level domain are required. (https://, .com)",
    logoLabel: "Logo URL",
    logoTitle: "Add a logo",
    themeSelectorTitle: "Select the {{title}} theme"
  },
  datePicker: {
    ariaLabel: "Change date",
    format: "MM/dd/yyyy",
    invalidDateMessage: "Invalid date format",
    maxDateMessage: "Date should not be after maximal date",
    minDateMessage: "Date should not be before minimal date"
  },
  dialogTitle: {
    closeDialogTooltip: "Close Dialog"
  },
  editableSlidingPanel: {
    closeDialogPropsTitle: "Unsaved Changes",
    closeDialogPropsContent: "You have unsaved changes which will be lost if you close this panel. Would you like to continue editing?",
    closeDialogPropsOKButtonProps: "Discard",
    closeDialogPropsCancelButtonProps: "Continue editing"
  },
  errorPageCodes: {
    "400": {
      actionLink: "Go to the Home Page",
      description: "We don't understand this request",
      header: "Bad request"
    },
    "401": {
      actionLink: "Log in",
      description: "You don't have permission to view this page. Log in to your account and if that doesn't work, contact your admin.",
      header: "Unauthorized"
    },
    "403": {
      actionLink: "Go to the Home Page",
      description: "You don't have permission to view this page. Contact your admin for access.",
      header: "Forbidden"
    },
    "404": {
      actionLink: "Go to the Home Page",
      description: "We couldn't find this page. What you're looking for has either been moved, deleted, or the link might be broken.",
      header: "Page not found"
    },
    "408": {
      actionLink: "Refresh page",
      description: "The server is taking too long to respond. Make sure you're connected to the internet, then try refreshing the page.",
      header: "Request timeout"
    },
    "500": {
      actionLink: "Go to the Home Page",
      description: "Something is not working on our end but it's temporary. Refresh this page or come back a bit later.",
      header: "Internal server error"
    },
    "501": {
      actionLink: "Go to the Home Page",
      description: "We're unable to display this content. Refresh the page or try again from the home page.",
      header: "Not implemented"
    },
    "502": {
      actionLink: "Go to the Home Page",
      description: "Something is not working on our end but it's temporary. Refresh this page or come back a bit later.",
      header: "Service temporarily overloaded",
      statusLink: "You can also check {{ status.sovos.com }} for updates."
    },
    "503": {
      actionLink: "Go to the Home Page",
      description: "Something is not working on our end but it's temporary. Refresh this page or come back a bit later.",
      header: "Service unavailable",
      statusLink: "You can also check {{ status.sovos.com }} for updates."
    }
  },
  file: {
    confirmDelete: "Delete File",
    confirmDeleteContent: "Are you sure you want to delete this file?"
  },
  fileUpload: {
    attemptDuplicatedFile: "Attempted to upload a duplicate file",
    button: "Browse",
    changeAction: "Change file",
    deleteAction: "Delete file",
    dragActive: "Drop here to upload",
    heading: "Upload new file",
    help: "Drag and drop or browse",
    ariaLabel: "File Upload",
    rejectedMessage: "Unable to upload file.",
    rejectedMessageDuplicated: "Duplicated file",
    rejectedMessageType: "Supported file types:",
    rejectedMessageSize: "File cannot exceed"
  },
  filterDateRange: {
    format: "MM/dd/yyyy",
    fromLabel: "Start Date",
    toLabel: "End Date",
    invalidStartDate: "Start date has invalid value",
    invalidEndDate: "End date has invalid value",
    endDateAfterStartDate: "End date must be after start date"
  },
  filterDrawer: {
    title: "Filters"
  },
  filterNumberRange: {
    fromLabel: "Start Value",
    startValueLessThanEndValue: "Start value must be less than end value",
    toLabel: "End Value",
    validationErrorMessage: "Invalid value"
  },
  group: {
    loading: "Loading Data"
  },
  historyTab: {
    emptyListLabel: "No events yet...",
    showLessLabel: "Show fewer events",
    showMoreLabel: "Show more events",
    label: "History"
  },
  iconAvatar: {
    tooltip: "System"
  },
  loginFlowForm: {
    errorMessage: "Something, went wrong, try again"
  },
  loginPage: {
    emptyPasswordError: "Password cannot be empty",
    emptyUsernameError: "Email address cannot be empty",
    forgotPassword: "Forgot password",
    header: "Welcome back!",
    invalidUsernameError: "Invalid email",
    login: "Log in",
    passwordPlaceholder: "Password",
    subtitle: "Enter your email address and password to view your account",
    usernamePlaceholder: "Email address",
    errorMessage: "Sorry, invalid login combination. For assistance, contact your system administrator or technical support."
  },
  monthRangePicker: {
    "default": "Start - End"
  },
  monthSelector: {
    specificMonthTooltip: "Go to a specific month",
    previousMonthTooltip: "Previous Month",
    nextMonthTooltip: "Next Month",
    thisMonth: "This Month"
  },
  minimizedNavigation: {
    ariaLabel: "Open Navigation"
  },
  navigation: {
    baseError: "'SovosNavigation' received an invalid link: links should have either nestedLinks or an action function, but received",
    productSwitcherLabel: "Product switcher"
  },
  navigationLinks: {
    showSubnavigationTooltip: "Show Subnavigation",
    hideSubnavigationTooltip: "Hide Subnavigation"
  },
  navigationFooter: {
    collapse: "Collapse",
    expand: "Expand",
    help: "Help"
  },
  noResultsLabels: {
    helpLabel: "Try adjusting your search or filter options to find what you are looking for",
    headingLabelData: "No data to display",
    helpLabelData: "No data is currently available to display"
  },
  orderableList: {
    addTooltip: "Add Item",
    header: "Drag & drop to modify the order",
    removeDisabledTooltipText: "No more items can be removed",
    removeTooltip: "Remove Item"
  },
  paginationFooter: {
    itemsPerPage: "show",
    nextPage: "Next Page",
    previousPage: "Previous Page",
    results: "results"
  },
  readOnlyDrawer: {
    closeDrawerTooltip: "Close Drawer"
  },
  resetPasswordStartPage: {
    back: "Back to sign in",
    emailPlaceholder: "Email",
    emptyEmailError: "Email address cannot be empty",
    header: "Reset password",
    invalidEmailError: "Invalid email",
    next: "next",
    subtitle: "Enter the email address associated with your account.",
    subtitle2: "If it matches an active account, we'll send you an email with instructions on how to reset your password."
  },
  resetPasswordSuccessPage: {
    header: "Password updated!",
    next: "Return to sign in",
    subtitle: "Your password has been reset successfully. Please use your new password and username to sign in to Sovos."
  },
  resetPasswordUpdatePage: {
    errorMessage: "You have used this password before, please try another",
    header: "Reset password",
    newPasswordHelperText: "Must contain at least 8 characters, including at least 1 capital, 1 numeric and 1 special character (!,@,#,$,%,&,*)",
    newPasswordPlaceholder: "New password",
    next: "Reset password",
    passwordConfirmationError: "Passwords do not match",
    passwordConfirmationPlaceholder: "Confirm password",
    subtitle: "Please create a new password. Your new password cannot be same as any of your historical passwords."
  },
  resetPasswordVerificationPage: {
    errorMessage: "The recovery code you entered is no longer valid",
    emptyRecoveryCodeError: "Recovery code cannot be empty",
    header: "Check recovery code",
    recoveryCodePlaceholder: "Recovery code",
    next: "Next",
    subtitle: "Enter the recovery code sent on your email.",
    subtitle2: "Don't leave this page, please."
  },
  table: {
    totals: "Totals"
  },
  toolbar: {
    columnDrawerTooltip: "Show/Hide Column",
    density: "Density",
    filters: "Filters",
    refresh: "Refresh"
  },
  toolbarDataGrouping: {
    emptyGroupings: "Group Data",
    editButton: "Edit Groupings",
    orderableListAddTooltip: "Add group",
    orderableListHeader: "Drag & drop to modify the order of your data groups",
    orderableListremoveTooltip: "Remove group",
    drawer: {
      title: "Data Groups",
      help: "Drag and drop to modify the order of data groups",
      addButton: "Add Data Group",
      searchPlaceHolder: "Search for Data Group"
    },
    item: {
      activeGroup: "All",
      inactiveGroup: "Select a row"
    }
  },
  toolbarDateSelector: {
    endDateAfterStartDateMessage: "End date must be after start date",
    format: "MM/dd/yyyy",
    fromLabel: "Start Date",
    invalidEndDateMessage: "End date has invalid value",
    invalidStartDateMessage: "Start date has invalid value",
    toLabel: "End Date"
  },
  toolbarBulkActions: {
    selected: "selected"
  },
  toolbarColumn: {
    tooltip: "Edit Columns"
  },
  toolbarFilter: {
    tooltip: "Filters"
  }
};
const esCommon = {
  add: "Agregar",
  apply: "Aplicar",
  cancel: "Cancelar",
  clear: "Limpiar",
  open: "Abrir",
  close: "Cerrar",
  "delete": "Eliminar",
  download: "Descargar",
  downloadAll: "Descargar todo",
  endDate: "Fecha final",
  endValue: "Valor final",
  more: "M\xE1s",
  noResults: "No se han encontrado resultados",
  reset: "Reiniciar",
  save: "Guardar",
  search: "Buscar",
  settings: "Ajustes",
  showLess: "Mostrar menos",
  showMore: "Mostrar m\xE1s",
  startDate: "Fecha de inicio",
  startValue: "Valor inicial",
  yourAccount: "Su cuenta",
  actions: {
    audit: "Auditar",
    "continue": "Continuar",
    clear: "Limpiar",
    create: "Crear",
    edit: "Editar",
    file: "Archivo",
    "import": "Importar",
    "new": "Nuevo",
    remove: "Eliminar",
    done: "Hecho"
  },
  commonWords: {
    assignee: "Asignatario",
    company: "Compa\xF1\xEDa",
    country: "Pa\xEDs",
    customer: "Cliente",
    deadline: "Fecha l\xEDmite",
    no: "No",
    only: "Solo",
    or: "o",
    "return": "Regresar",
    required: "Requerido",
    saved: "Guardado",
    task: "Tarea",
    vendor: "Proveedor",
    yes: "S\xED"
  },
  friendlyTimestamp: {
    seconds: "s",
    minutes: "m",
    hours: "h",
    day: "d",
    ago: "hace",
    today: "hoy",
    tomorrow: "ma\xF1ana"
  },
  months: {
    january: "Enero",
    february: "Febrero",
    march: "Marzo",
    april: "Abril",
    may: "Mayo",
    june: "Junio",
    july: "Julio",
    august: "Agosto",
    september: "Septiembre",
    october: "Octubre",
    november: "Noviembre",
    december: "Diciembre"
  },
  monthsAbbrev: {
    january: "Ene",
    february: "Feb",
    march: "Mar",
    april: "Abr",
    may: "May",
    june: "Jun",
    july: "Jul",
    august: "Ago",
    september: "Sep",
    october: "Oct",
    november: "Nov",
    december: "Dic"
  }
};
const esS1Ui = {
  aboutThis: {
    learnMore: "Aprender m\xE1s acerca de",
    privacyPolicy: "Pol\xEDtica de Privacidad",
    termsAndConditions: "T\xE9rminos y Condiciones",
    version: "Versi\xF3n"
  },
  accountSwitcher: {
    production: "Producci\xF3n",
    test: "Pruebas"
  },
  attachmentsTab: {
    label: "Archivos adjuntos"
  },
  attachmentsListTab: {
    emptyListLabel: "No hay archivos adjuntos",
    primaryButtonLabel: "Adjuntar archivo"
  },
  autocomplete: {
    helpMessageTemplate: "No hay nada para buscar",
    loadingMessage: "Buscando"
  },
  avatar: {
    noName: "Sin asignar"
  },
  commentsTab: {
    label: "Comentarios"
  },
  closeButton: {
    toolTip: "Cerrar"
  },
  columnDrawer: {
    addTooltipText: "Mostrar columna",
    header: "Arrastre y suelte las columnas para reordenarlas",
    removeTooltipText: "Ocultar columna",
    removeDisabledTooltipText: "Debe mostrar al menos 1 columna",
    title: "Columnas"
  },
  commentForm: {
    attachmentButtonTooltipText: "Adjuntar archivo",
    commentPlaceholder: "Escriba para dejar un comentario...",
    errorEmpty: "No hay ning\xFAn comentario.",
    errorLength: "El comentario debe tener menos de 500 caracteres.",
    submitButton: "Enviar comentario"
  },
  commentsListTab: {
    emptyListLabel: "Sin comentarios...",
    showLessLabel: "Mostrar menos comentarios",
    showMoreLabel: "Mostrar m\xE1s comentarios",
    tabPropsLabel: "Comentarios"
  },
  confirmationDialog: {
    defaultTitle: "\xBFEst\xE1 seguro?",
    defaultContent: "Una confirmaci\xF3n positiva como Transmitir, debe tener 2 botones: Cancelar (bot\xF3n secundario) y 'Acci\xF3n positiva' (bot\xF3n principal). Una confirmaci\xF3n negativa como Eliminar, debe tener 2 acciones: Cancelar (bot\xF3n principal) y 'Acci\xF3n negativa' en un bot\xF3n rojo."
  },
  customThemePage: {
    chooseTitle: "Elija su tema",
    clearLogoTooltip: "Limpiar URL del logotipo",
    colorPickerAriaLabel: "Selector de Color",
    customizeTitle: "Personalizar",
    defaultContentText: "\xBFDesea sobrescribir el tema personalizado con los colores seleccionados?",
    defaultLabels: {
      logoDescription: {
        recommended: "Formatos de archivo recomendados: archivo .svg, .webp o .png con fondo transparente.",
        note: "Nota: El archivo cargado se escalar\xE1 proporcionalmente a una altura de 22 p\xEDxeles. El nuevo logo aparecer\xE1 inmediatamente en la navegaci\xF3n.",
        warning: "Para utilizar el logotipo de SOVOS predeterminado, elimine el archivo cargado."
      },
      logoAltLabel: "Texto alternativo del logotipo",
      logoAltHelptext: "Se requiere de un texto alternativo para que el logotipo personalizado sea accesible",
      chooseTitle: "Elija su tema",
      chooseDescription: "Elija un tema. Puede personalizarlo en el siguiente paso.",
      customizeTitle: "Personalizar",
      customizeDescription: "Ajuste su paleta de colores.",
      customSubtitles: {
        highlights: "Acentos y realces del men\xFA.",
        gradientBottom: "Fondo degradado del men\xFA.",
        gradientTop: "Fondo del men\xFA degradado superior.",
        productIconColor: "Fondo del conmutador de productos",
        textColor: "Texto que aparece en el men\xFA."
      }
    },
    defaultTitleText: "Sobrescribir colores personalizados",
    logoHelptext: "Se requiere protocolo y dominio de nivel superior. (https://, .com)",
    logoLabel: "URL del logotipo",
    logoTitle: "Agregar logotipo",
    themeSelectorTitle: "Seleccione el tema {{title}}"
  },
  datePicker: {
    ariaLabel: "Cambiar fecha",
    format: "MM/dd/yyyy",
    invalidDateMessage: "Formato de fecha inv\xE1lido",
    maxDateMessage: "La fecha no debe ser posterior a la fecha m\xE1xima",
    minDateMessage: "La fecha no debe ser anterior a la fecha m\xEDnima"
  },
  dialogTitle: {
    closeDialogTooltip: "Cerrar"
  },
  editableSlidingPanel: {
    closeDialogPropsTitle: "Cambios no guardados",
    closeDialogPropsContent: "Tiene cambios sin guardar que se perder\xE1n si cierra este panel \xBFdesea continuar edit\xE1ndolo?",
    closeDialogPropsOKButtonProps: "Descartar",
    closeDialogPropsCancelButtonProps: "Continuar editando"
  },
  errorPageCodes: {
    "400": {
      actionLink: "Ir a la p\xE1gina de inicio",
      description: "No entendemos esta solicitud.",
      header: "Solicitud incorrecta"
    },
    "401": {
      actionLink: "Iniciar sesi\xF3n",
      description: "No tiene permiso para ver esta p\xE1gina. Inicie sesi\xF3n en su cuenta y si el error persiste, p\xF3ngase en contacto con su administrador.",
      header: "No autorizado"
    },
    "403": {
      actionLink: "Ir a la p\xE1gina de inicio",
      description: "No tiene permiso para ver esta p\xE1gina. P\xF3ngase en contacto con su administrador para obtener acceso.",
      header: "Prohibido"
    },
    "404": {
      actionLink: "Ir a la p\xE1gina de inicio",
      description: "No pudimos encontrar esta p\xE1gina. La informaci\xF3n que est\xE1 buscando se ha movido de p\xE1gina, eliminado o tal vez el enlace est\xE9 roto.",
      header: "P\xE1gina no encontrada"
    },
    "408": {
      actionLink: "Actualizar p\xE1gina",
      description: "El servidor est\xE1 tardando demasiado en responder. Aseg\xFArese de estar conectado a Internet y luego intente actualizar la p\xE1gina.",
      header: "Tiempo de espera agotado"
    },
    "500": {
      actionLink: "Ir a la p\xE1gina de inicio",
      description: "Algo no funciona de nuestra parte, pero es temporal. Actualice esta p\xE1gina o int\xE9ntelo de nuevo m\xE1s tarde.",
      header: "Error interno del servidor"
    },
    "501": {
      actionLink: "Ir a la p\xE1gina de inicio",
      description: "No podemos mostrar este contenido. Actualice la p\xE1gina o int\xE9ntelo nuevamente desde la p\xE1gina de inicio.",
      header: "No se ha implementado"
    },
    "502": {
      actionLink: "Ir a la p\xE1gina de inicio",
      description: "Algo no funciona de nuestra parte, pero es temporal. Actualice esta p\xE1gina o int\xE9ntelo de nuevo m\xE1s tarde.",
      header: "Servicio temporalmente sobrecargado",
      statusLink: "Tambi\xE9n puede consultar {{ status.sovos.com }} para obtener actualizaciones."
    },
    "503": {
      actionLink: "Ir a la p\xE1gina de inicio",
      description: "Algo no funciona de nuestra parte, pero es temporal. Actualice esta p\xE1gina o int\xE9ntelo de nuevo m\xE1s tarde.",
      header: "Servicio no disponible",
      statusLink: "Tambi\xE9n puede consultar {{ status.sovos.com }} para obtener actualizaciones."
    }
  },
  file: {
    confirmDelete: "Eliminar archivo",
    confirmDeleteContent: "\xBFEst\xE1 seguro que desea eliminar este archivo?"
  },
  fileUpload: {
    attemptDuplicatedFile: "Intent\xF3 subir un archivo duplicado",
    button: "Navegar",
    changeAction: "Cambiar archivo",
    deleteAction: "Eliminar archivo",
    dragActive: "Suelte aqu\xED para subir",
    heading: "Subir nuevo archivo",
    help: "Arrastrar y soltar o navegar",
    ariaLabel: "Subir archivo",
    rejectedMessage: "No es posible subir el archivo.",
    rejectedMessageDuplicated: "Archivo duplicado",
    rejectedMessageType: "Tipos de archivos compatibles:",
    rejectedMessageSize: "El archivo no puede exceder"
  },
  filterDateRange: {
    format: "MM/dd/yyyy",
    fromLabel: "Fecha de inicio",
    toLabel: "Fecha final",
    invalidStartDate: "La fecha de inicio es inv\xE1lida",
    invalidEndDate: "La fecha final es inv\xE1lida",
    endDateAfterStartDate: "La fecha final debe ser posterior a la fecha de inicio"
  },
  filterDrawer: {
    title: "Filtros"
  },
  filterNumberRange: {
    fromLabel: "Valor inicial",
    startValueLessThanEndValue: "El valor inicial debe ser menor que el valor final",
    toLabel: "Valor final",
    validationErrorMessage: "Valor inv\xE1lido"
  },
  group: {
    loading: "Cargando datos"
  },
  historyTab: {
    emptyListLabel: "A\xFAn no hay eventos...",
    showLessLabel: "Mostrar menos eventos",
    showMoreLabel: "Mostrar m\xE1s eventos",
    label: "Historia"
  },
  iconAvatar: {
    tooltip: "Sistema"
  },
  loginFlowForm: {
    errorMessage: "Algo sali\xF3 mal. Por favor int\xE9ntelo de nuevo"
  },
  loginPage: {
    emptyPasswordError: "La contrase\xF1a no puede estar vac\xEDa",
    emptyUsernameError: "La direcci\xF3n de correo electr\xF3nico no puede estar vac\xEDa",
    forgotPassword: "\xBFOlvid\xF3 su contrase\xF1a?",
    header: "\xA1Bienvenido de nuevo!",
    invalidUsernameError: "Direcci\xF3n de correo inv\xE1lida",
    login: "Iniciar sesi\xF3n",
    passwordPlaceholder: "Contrase\xF1a",
    subtitle: "Ingrese su correo electr\xF3nico y contrase\xF1a para ver su cuenta",
    usernamePlaceholder: "Correo electr\xF3nico",
    errorMessage: "Lo sentimos, la combinaci\xF3n de inicio de sesi\xF3n no es v\xE1lida. Para obtener ayuda, comun\xEDquese con el administrador del sistema o con soporte t\xE9cnico."
  },
  monthRangePicker: {
    "default": "Inicio - Fin"
  },
  monthSelector: {
    specificMonthTooltip: "Ir a un mes espec\xEDfico",
    previousMonthTooltip: "Mes anterior",
    nextMonthTooltip: "Siguiente mes",
    thisMonth: "Mes actual"
  },
  minimizedNavigation: {
    ariaLabel: "Mostrar navegaci\xF3n"
  },
  navigation: {
    baseError: "'SovosNavigation' recibi\xF3 un enlace no v\xE1lido: los enlaces deber\xEDan tener enlaces anidados o una funci\xF3n de acci\xF3n, pero recibieron",
    productSwitcherLabel: "Conmutador de productos"
  },
  navigationLinks: {
    showSubnavigationTooltip: "Mostrar subnavegaci\xF3n",
    hideSubnavigationTooltip: "Ocultar subnavegaci\xF3n"
  },
  navigationFooter: {
    collapse: "Colapsar",
    expand: "Expandir",
    help: "Ayuda"
  },
  noResultsLabels: {
    helpLabel: "Intente ajustar sus opciones de b\xFAsqueda o filtros para encontrar lo que est\xE1 buscando",
    headingLabelData: "No hay informaci\xF3n para mostrar",
    helpLabelData: "No hay datos disponibles para mostrar actualmente"
  },
  orderableList: {
    addTooltip: "Agregar art\xEDculo",
    header: "Arrastre y suelte para cambiar el orden",
    removeDisabledTooltipText: "No se pueden eliminar m\xE1s elementos.",
    removeTooltip: "Remover art\xEDculo"
  },
  paginationFooter: {
    itemsPerPage: "mostrar",
    nextPage: "Siguiente p\xE1gina",
    previousPage: "P\xE1gina anterior",
    results: "resultados"
  },
  readOnlyDrawer: {
    closeDrawerTooltip: "Cerrar panel"
  },
  resetPasswordStartPage: {
    back: "Volver al inicio de sesi\xF3n",
    emailPlaceholder: "Correo electr\xF3nico",
    emptyEmailError: "El correo electr\xF3nico no puede estar vac\xEDo",
    header: "Restablecer contrase\xF1a",
    invalidEmailError: "Correo electr\xF3nico inv\xE1lido",
    next: "siguiente",
    subtitle: "Introduzca el correo electr\xF3nico asociado a su cuenta.",
    subtitle2: "Si coincide con una cuenta activa, le enviaremos un correo electr\xF3nico con instrucciones sobre c\xF3mo restablecer su contrase\xF1a."
  },
  resetPasswordSuccessPage: {
    header: "\xA1Contrase\xF1a actualizada!",
    next: "Volver al inicio de sesi\xF3n",
    subtitle: "Su contrase\xF1a ha sido restablecida con \xE9xito. Utilice su nueva contrase\xF1a y nombre de usuario para iniciar sesi\xF3n en Sovos."
  },
  resetPasswordUpdatePage: {
    errorMessage: "Ha utilizado esta contrase\xF1a antes, intente con otra",
    header: "Restablecer contrase\xF1a",
    newPasswordHelperText: "Debe contener al menos 8 caracteres, incluyendo 1 may\xFAscula, 1 n\xFAmero y 1 car\xE1cter especial (!,@,#,$,%,&,*)",
    newPasswordPlaceholder: "Nueva contrase\xF1a",
    next: "Restablecer contrase\xF1a",
    passwordConfirmationError: "Las contrase\xF1as no coinciden",
    passwordConfirmationPlaceholder: "Confirmar contrase\xF1a",
    subtitle: "Cree una nueva contrase\xF1a. Su nueva contrase\xF1a no puede ser la misma que ninguna de sus contrase\xF1as hist\xF3ricas."
  },
  resetPasswordVerificationPage: {
    errorMessage: "El c\xF3digo de recuperaci\xF3n que ingres\xF3 ya no es v\xE1lido",
    emptyRecoveryCodeError: "El c\xF3digo de recuperaci\xF3n no puede estar vac\xEDo",
    header: "Comprobar c\xF3digo de recuperaci\xF3n",
    recoveryCodePlaceholder: "C\xF3digo de recuperaci\xF3n",
    next: "Siguiente",
    subtitle: "Ingrese el c\xF3digo de recuperaci\xF3n enviado en su correo electr\xF3nico.",
    subtitle2: "Por favor, no abandone esta p\xE1gina."
  },
  table: {
    totals: "Totales"
  },
  toolbar: {
    columnDrawerTooltip: "Mostrar/ocultar columna",
    density: "Densidad",
    filters: "Filtros",
    refresh: "Actualizar"
  },
  toolbarDataGrouping: {
    emptyGroupings: "Datos de grupo",
    editButton: "Editar agrupaciones",
    orderableListAddTooltip: "Agregar grupo",
    orderableListHeader: "Arrastre y suelte para modificar el orden de los grupos de datos",
    orderableListremoveTooltip: "Quitar grupo",
    drawer: {
      title: "Grupos de datos",
      help: "Arrastre y suelte para modificar el orden de los grupos de datos",
      addButton: "Agregar grupo de datos",
      searchPlaceHolder: "Buscar grupo de datos"
    },
    item: {
      activeGroup: "Todo",
      inactiveGroup: "Seleccione una fila"
    }
  },
  toolbarDateSelector: {
    endDateAfterStartDateMessage: "La fecha final debe ser posterior a la fecha de inicio",
    format: "MM/dd/yyyy",
    fromLabel: "Fecha de inicio",
    invalidEndDateMessage: "La fecha final no es v\xE1lida",
    invalidStartDateMessage: "La fecha de inicio no es v\xE1lida",
    toLabel: "Fecha final"
  },
  toolbarBulkActions: {
    selected: "seleccionado"
  },
  toolbarColumn: {
    tooltip: "Editar columnas"
  },
  toolbarFilter: {
    tooltip: "Filtros"
  }
};
const ptBRCommon = {
  add: "Adicionar",
  apply: "Aplicar",
  cancel: "Cancelar",
  clear: "Limpar",
  close: "Fechar",
  "delete": "Deletar",
  download: "Baixar",
  downloadAll: "Baixar Tudo",
  endDate: "Data final",
  endValue: "Valor Final",
  more: "Mais",
  noResults: "N\xE3o foram encontrados resultados",
  open: "Abrir",
  reset: "Resetar",
  save: "Salvar",
  search: "Buscar",
  settings: "Configura\xE7\xF5es",
  showLess: "Mostrar menos",
  showMore: "Mostrar mais",
  startDate: "Data In\xEDcio",
  startValue: "Valor Inicial",
  yourAccount: "Sua conta",
  actions: {
    audit: "Auditoria",
    "continue": "Continuar",
    clear: "Limpar",
    create: "Criar",
    edit: "Editar",
    file: "Arquivo",
    "import": "Importar",
    "new": "Novo",
    remove: "Remover",
    done: "Feito"
  },
  commonWords: {
    assignee: "Administrador",
    company: "Empresa",
    country: "Pa\xEDs",
    customer: "Cliente",
    deadline: "Prazo Limite",
    no: "N\xE3o",
    only: "Apenas",
    or: "ou",
    "return": "Retornar",
    required: "Requisito",
    saved: "Salvo",
    task: "Tarefa",
    vendor: "Fornecedor",
    yes: "Sim"
  },
  friendlyTimestamp: {
    seconds: "s",
    minutes: "m",
    hours: "h",
    day: "d",
    ago: "atr\xE1s",
    today: "hoje",
    tomorrow: "amanh\xE3"
  },
  months: {
    january: "Janeiro",
    february: "Fevereiro",
    march: "Mar\xE7o",
    april: "Abril",
    may: "Maio",
    june: "Junho",
    july: "Julho",
    august: "Agosto",
    september: "Setembro",
    october: "Outubro",
    november: "Novembro",
    december: "Dezembro"
  },
  monthsAbbrev: {
    january: "Jan",
    february: "Fev",
    march: "Mar",
    april: "Abr",
    may: "Mai",
    june: "Jun",
    july: "Jul",
    august: "Ago",
    september: "Set",
    october: "Out",
    november: "Nov",
    december: "Dez"
  }
};
const ptBRS1Ui = {
  aboutThis: {
    learnMore: "Saiba mais sobre",
    privacyPolicy: "Pol\xEDtica de Privacidade",
    termsAndConditions: "Termos e Condi\xE7\xF5es",
    version: "Vers\xE3o"
  },
  accountSwitcher: {
    production: "Produ\xE7\xE3o",
    test: "Teste"
  },
  attachmentsTab: {
    label: "Anexos"
  },
  attachmentsListTab: {
    emptyListLabel: "Ainda n\xE3o h\xE1 anexos",
    primaryButtonLabel: "Adicionar anexos"
  },
  autocomplete: {
    helpMessageTemplate: "Necess\xE1rio caracteres para pesquisa",
    loadingMessage: "Pesquisando"
  },
  avatar: {
    noName: "N\xE3o atribu\xEDdo"
  },
  commentsTab: {
    label: "Coment\xE1rios"
  },
  closeButton: {
    toolTip: "Fechar Painel"
  },
  columnDrawer: {
    addTooltipText: "Mostrar coluna",
    header: "Arraste e solte para reorganizar colunas",
    removeTooltipText: "Ocultar coluna",
    removeDisabledTooltipText: "Voc\xEA deve exibir pelo menos 1 coluna",
    title: "Colunas"
  },
  commentForm: {
    attachmentButtonTooltipText: "Adicionar anexo",
    commentPlaceholder: "Digite para deixar um coment\xE1rio.",
    errorEmpty: "Coment\xE1rio est\xE1 vazio.",
    errorLength: "Coment\xE1rio deve ter menos de 500 caracteres.",
    submitButton: "Coment\xE1rio"
  },
  commentsListTab: {
    emptyListLabel: "Nenhum coment\xE1rio ainda...",
    showLessLabel: "Mostrar menos coment\xE1rios",
    showMoreLabel: "Mostrar mais coment\xE1rios",
    tabPropsLabel: "Coment\xE1rios"
  },
  confirmationDialog: {
    defaultTitle: "Voc\xEA tem certeza?",
    defaultContent: "Uma confirma\xE7\xE3o positiva, como Transmit, deve ter 2 bot\xE3os: Cancelar (Bot\xE3o secund\xE1rio) e 'A\xE7\xE3o Positiva' (Bot\xE3o Prim\xE1rio). Uma confirma\xE7\xE3o negativa, como Delete, deve ter 2 a\xE7\xF5es, Cancelar (bot\xE3o prim\xE1rio) e 'A\xE7\xE3o Negativa' em um bot\xE3o vermelho."
  },
  customThemePage: {
    chooseTitle: "Escolha seu tema",
    clearLogoTooltip: "Limpar URL do logotipo",
    colorPickerAriaLabel: "Seletor de Cores",
    customizeTitle: "Customizar",
    defaultContentText: "Deseja substituir o tema personalizado pelas cores selecionadas?",
    defaultTitleText: "Substituir cores personalizadas",
    defaultLabels: {
      logoDescription: {
        recommended: "Formatos de arquivo recomendados: arquivo .svg, .webp ou .png com fundo transparente.",
        note: "Observa\xE7\xE3o: o arquivo carregado ser\xE1 dimensionado proporcionalmente para uma altura de 22 pixels. O novo logotipo aparecer\xE1 imediatamente na navega\xE7\xE3o.",
        warning: "Para usar o logotipo SOVOS padr\xE3o, remova o arquivo carregado."
      },
      logoAltLabel: "Texto alternativo do logotipo",
      logoAltHelptext: "O texto alternativo para logotipo personalizado \xE9 necess\xE1rio para acessibilidade",
      chooseTitle: "Escolha seu tema",
      chooseDescription: "Escolha um tema. Voc\xEA pode personaliz\xE1-lo na pr\xF3xima etapa.",
      customizeTitle: "Customizar",
      customizeDescription: "Ajuste sua paleta de cores.",
      customSubtitles: {
        highlights: "Acentos e destaques do menu.",
        gradientBottom: "Gradiente inferior do plano de fundo do menu.",
        gradientTop: "Gradiente superior do plano de fundo do menu.",
        productIconColor: "Fundo do chaveador de produto",
        textColor: "Texto que aparece no menu."
      }
    },
    logoHelptext: "Protocolo e dom\xEDnio top-level s\xE3o obrigat\xF3rios: (https://, .com)",
    logoLabel: "Logo da URL",
    logoTitle: "Adicionar uma logo",
    themeSelectorTitle: "Selecione o tema {{title}}"
  },
  datePicker: {
    ariaLabel: "Mudar data",
    format: "MM/dd/yyyy",
    invalidDateMessage: "Formato de data inv\xE1lida",
    maxDateMessage: "Data n\xE3o deve ser definida depois da data m\xE1xima",
    minDateMessage: "Data n\xE3o deve ser definida depois da data min\xEDma"
  },
  dialogTitle: {
    closeDialogTooltip: "Fechar Di\xE1logo"
  },
  editableSlidingPanel: {
    closeDialogPropsTitle: "Mudan\xE7as n\xE3o salvas",
    closeDialogPropsContent: "Voc\xEA tem mudan\xE7as n\xE3o salvas que ir\xE3o ser perdidas se voc\xEA fechar este painel. Voc\xEA deseja continuar editando?",
    closeDialogPropsOKButtonProps: "Descartar",
    closeDialogPropsCancelButtonProps: "Continuar editando"
  },
  errorPageCodes: {
    "400": {
      actionLink: "V\xE1 para a p\xE1gina inicial",
      description: "N\xE3o entendemos essa requisi\xE7\xE3o",
      header: "Requisi\xE7\xE3o incorreta"
    },
    "401": {
      actionLink: "Iniciar sess\xE3o.",
      description: "Voc\xEA n\xE3o tem permiss\xE3o para visualizar esta p\xE1gina. Fa\xE7a login em sua conta e se isso n\xE3o funcionar, entre em contato com seu administrador.",
      header: "N\xE3o autorizado"
    },
    "403": {
      actionLink: "V\xE1 para a pagina inicial",
      description: "Voc\xEA n\xE3o tem permiss\xE3o para visualizar esta p\xE1gina. Entre em contato com seu administrador para obter acesso.",
      header: "Proibido"
    },
    "404": {
      actionLink: "V\xE1 para a pagina inicial",
      description: "N\xE3o foi poss\xEDvel encontrar esta p\xE1gina. O que voc\xEA procura foi movido, exclu\xEDdo ou o link pode estar quebrado.",
      header: "P\xE1gina n\xE3o encontrada"
    },
    "408": {
      actionLink: "Atualize a p\xE1gina",
      description: "O servidor est\xE1 demorando muito para responder. Verifique se voc\xEA est\xE1 conectado \xE0 Internet e tente atualizar a p\xE1gina.",
      header: "Tempo esgotado para request"
    },
    "500": {
      actionLink: "V\xE1 para a pagina inicial",
      description: "Algo n\xE3o est\xE1 funcionando do nosso lado, mas \xE9 tempor\xE1rio. Atualize esta p\xE1gina ou volte um pouco mais tarde.",
      header: "Erro interno do servidor"
    },
    "501": {
      actionLink: "V\xE1 para a pagina inicial",
      description: "N\xE3o foi poss\xEDvel exibir este conte\xFAdo. Atualize a p\xE1gina ou tente novamente na p\xE1gina inicial.",
      header: "N\xE3o implementado"
    },
    "502": {
      actionLink: "V\xE1 para a pagina inicial",
      description: "Algo n\xE3o est\xE1 funcionando do nosso lado, mas \xE9 tempor\xE1rio. Atualize esta p\xE1gina ou volte um pouco mais tarde.",
      header: "Servi\xE7o temporariamente sobrecarregado",
      statusLink: "Voc\xEA tamb\xE9m pode verificar {{ status.sovos.com }} para atualiza\xE7\xF5es."
    },
    "503": {
      actionLink: "V\xE1 para a pagina inicial",
      description: "Algo n\xE3o est\xE1 funcionando do nosso lado, mas \xE9 tempor\xE1rio. Atualize esta p\xE1gina ou volte um pouco mais tarde.",
      header: "Servi\xE7o n\xE3o dispon\xEDvel",
      statusLink: "Voc\xEA tamb\xE9m pode verificar {{ status.sovos.com }} para atualiza\xE7\xF5es."
    }
  },
  file: {
    confirmDelete: "Deletar Arquivo",
    confirmDeleteContent: "Voc\xEA tem certeza que quer deletar esse arquivo?"
  },
  fileUpload: {
    attemptDuplicatedFile: "Tentativa de fazer de arquivo duplicado",
    button: "Pesquise",
    changeAction: "Mudar arquivo",
    deleteAction: "Deletar arquivo",
    dragActive: "Solte aqui para carregar",
    heading: "Carregar novo arquivo",
    help: "Arraste e solte ou pesquise",
    ariaLabel: "Carregar Arquivo",
    rejectedMessage: "Incapaz de fazer upload deste arquivo.",
    rejectedMessageDuplicated: "Arquivo duplicado",
    rejectedMessageType: "Tipos de arquivos suportados:",
    rejectedMessageSize: "Arquivo n\xE3o pode exceder"
  },
  filterDateRange: {
    format: "MM/dd/yyyy",
    fromLabel: "Data de in\xEDcio",
    invalidStartDate: "Data de in\xEDcio tem valor inv\xE1lido",
    invalidEndDate: "Data final tem valor inv\xE1lido",
    endDateAfterStartDate: "Data final deve ser posterior \xE0 data inicial",
    toLabel: "Data final"
  },
  filterDrawer: {
    title: "Filtros"
  },
  filterNumberRange: {
    fromLabel: "Valor inicial",
    startValueLessThanEndValue: "Valor final deve ser menor ao valor inicial",
    toLabel: "Valor final",
    validationErrorMessage: "Valor inv\xE1lido"
  },
  group: {
    loading: "Carregando dados"
  },
  historyTab: {
    emptyListLabel: "Nenhum evento ainda...",
    label: "Hist\xF3rico",
    showMoreLabel: "Mostre Mais",
    showLessLabel: "Mostre Menos"
  },
  iconAvatar: {
    tooltip: "Sistema"
  },
  loginFlowForm: {
    errorMessage: "Alguma coisa deu errado, tente novamente."
  },
  loginPage: {
    emptyPasswordError: "Senha n\xE3o pode estar vazia",
    emptyUsernameError: "Endere\xE7o de email n\xE3o pode estar vazio",
    forgotPassword: "Esqueci a senha",
    header: "Bem vindo de volta!",
    invalidUsernameError: "Email inv\xE1lido",
    login: "Iniciar sess\xE3o",
    passwordPlaceholder: "Senha",
    subtitle: "Digite seu endere\xE7o de email e senha para visualizar sua conta",
    usernamePlaceholder: "Endere\xE7o de email",
    errorMessage: "Desculpe, combina\xE7\xE3o de login inv\xE1lida. Para obter assist\xEAncia, entre em contato com o administrador do sistema ou com o suporte t\xE9cnico."
  },
  monthRangePicker: {
    "default": "In\xEDcio - Fim"
  },
  monthSelector: {
    specificMonthTooltip: "Ir para um m\xEAs espec\xEDfico",
    previousMonthTooltip: "M\xEAs anterior",
    nextMonthTooltip: "Pr\xF3ximo m\xEAs",
    thisMonth: "Esse m\xEAs"
  },
  minimizedNavigation: {
    ariaLabel: "Abrir Navega\xE7\xE3o"
  },
  navigation: {
    baseError: "'SovosNavigation' recebeu um link inv\xE1lido: links devem ter nestedLinks ou uma fun\xE7\xE3o de a\xE7\xE3o, mas recebido",
    productSwitcherLabel: "Chaveador de produto"
  },
  navigationLinks: {
    showSubnavigationTooltip: "Mostrar Subnavigation",
    hideSubnavigationTooltip: "Ocultar Subnavigation"
  },
  navigationFooter: {
    collapse: "Colapso",
    expand: "Expandir",
    help: "Ajuda"
  },
  noResultsLabels: {
    helpLabel: "Tente ajustar sua pesquisa ou filtre suas op\xE7\xF5es para encontrar o que voc\xEA est\xE1 procurando",
    headingLabelData: "Nenhum dado para exibir",
    helpLabelData: "Nenhum dado est\xE1 dispon\xEDvel neste momento para ser exibido"
  },
  orderableList: {
    addTooltip: "Adicionar Item",
    header: "Arraste e soltepara modificar a ordem",
    removeDisabledTooltipText: "N\xE3o existem mais itens para remover",
    removeTooltip: "Remover Item"
  },
  paginationFooter: {
    itemsPerPage: "mostrar",
    nextPage: "Pr\xF3xima p\xE1gina",
    previousPage: "P\xE1gina anterior",
    results: "resultados"
  },
  readOnlyDrawer: {
    closeDrawerTooltip: "Fechar Gaveta"
  },
  resetPasswordStartPage: {
    back: "Voltar para sign in",
    emailPlaceholder: "Email",
    emptyEmailError: "Endere\xE7o de email n\xE3o deve ficar vazio",
    header: "Criar nova senha",
    invalidEmailError: "Email inv\xE1lido",
    next: "pr\xF3ximo",
    subtitle: "Inserir endere\xE7o de email associadp a sua conta.",
    subtitle2: "Se combinar com uma conta ativa, n\xF3s vamos enviar um emailo com instru\xE7\xF5es sobre como criar uma nova senha."
  },
  resetPasswordSuccessPage: {
    header: "Senha atualizada!",
    next: "Voltar para sign in",
    subtitle: "Sua senha foi atualizada com sucesso. Por favor, use sua nova senha e username para fazer sign-in na Sovos."
  },
  resetPasswordUpdatePage: {
    errorMessage: "Voc\xEA j\xE1 usou esta senha anteriormente, por favor, tente uma nova senha",
    header: "Criar nova senha",
    newPasswordHelperText: "Deve conter, pelo menos, 8 caracteres, incluindo, no m\xEDnimo, 1 letra mai\xFAscula, 1 n\xFAmero e 1 caractere especial (!,@,#,$,%,&,*)",
    newPasswordPlaceholder: "Nova senha",
    next: "Criar nova senha",
    passwordConfirmationError: "Senhas n\xE3o combinam",
    passwordConfirmationPlaceholder: "Confirmar senha",
    subtitle: "Por favor, crie uma nova senha. Sua nova senha n\xE3o deve ser a mesma do seu hist\xF3rico de senhas."
  },
  resetPasswordVerificationPage: {
    errorMessage: "O c\xF3digo de recupera\xE7\xE3o que voc\xEA inseriu n\xE3o \xE9 mais v\xE1lido",
    emptyRecoveryCodeError: "C\xF3digo de recupera\xE7\xE3o n\xE3o pode estar v\xE1zio",
    header: "Checar c\xF3digo de recupera\xE7\xE3o",
    recoveryCodePlaceholder: "C\xF3digo de recupera\xE7\xE3o",
    next: "Pr\xF3ximo",
    subtitle: "Inserir o c\xF3digo de recupera\xE7\xE3o enviado por email.",
    subtitle2: "N\xE3o saia desta p\xE1gina, por favor."
  },
  table: {
    totals: "Totais"
  },
  toolbar: {
    columnDrawerTooltip: "Mostrar/Ocultar Colunas",
    density: "Densidade",
    filters: "Filtros",
    refresh: "Atualizar"
  },
  toolbarDataGrouping: {
    emptyGroupings: "Grupo de dados",
    editButton: "Editar agrupamentos",
    orderableListAddTooltip: "Adicionar grupo",
    orderableListHeader: "Arraste e solte para modificar a ordem dos seus grupo de dados",
    orderableListremoveTooltip: "Remover grupo",
    drawer: {
      title: "Grupos de dados",
      help: "Arraste e solte para modificar a ordem dos seus grupos de dados",
      addButton: "Adicionar grupo de dados",
      searchPlaceHolder: "Pesquisar por dados em grupo"
    },
    item: {
      activeGroup: "Todos",
      inactiveGroup: "Selecione uma linha"
    }
  },
  toolbarDateSelector: {
    endDateAfterStartDateMessage: "Data final deve ser posterior \xE0 data inicial",
    format: "MM/dd/yyyy",
    fromLabel: "Data de in\xEDcio",
    invalidEndDateMessage: "Data final tem valor inv\xE1lido",
    invalidStartDateMessage: "Data de in\xEDcio tem valor inv\xE1lido",
    toLabel: "Data final"
  },
  toolbarBulkActions: {
    selected: "selecionado"
  },
  toolbarColumn: {
    tooltip: "Editar colunas"
  },
  toolbarFilter: {
    tooltip: "Filtros"
  }
};
const ptPTCommon = {
  add: "Adicionar",
  apply: "Aplicar",
  cancel: "Cancelar",
  clear: "Limpar",
  close: "Fechar",
  "delete": "Deletar",
  download: "Baixar",
  downloadAll: "Baixar Tudo",
  endDate: "Data final",
  endValue: "Valor Final",
  more: "Mais",
  noResults: "N\xE3o foram encontrados resultados",
  open: "Abrir",
  reset: "Resetar",
  save: "Salvar",
  search: "Buscar",
  settings: "Configura\xE7\xF5es",
  showLess: "Mostrar menos",
  showMore: "Mostrar mais",
  startDate: "Data In\xEDcio",
  startValue: "Valor Inicial",
  yourAccount: "Sua conta",
  actions: {
    audit: "Auditoria",
    "continue": "Continuar",
    clear: "Limpar",
    create: "Criar",
    edit: "Editar",
    file: "Arquivo",
    "import": "Importar",
    "new": "Novo",
    remove: "Remover",
    done: "Feito"
  },
  commonWords: {
    assignee: "Administrador",
    company: "Empresa",
    country: "Pa\xEDs",
    customer: "Cliente",
    deadline: "Prazo Limite",
    no: "N\xE3o",
    only: "Apenas",
    or: "ou",
    "return": "Retornar",
    required: "Requisito",
    saved: "Salvo",
    task: "Tarefa",
    vendor: "Fornecedor",
    yes: "Sim"
  },
  friendlyTimestamp: {
    seconds: "s",
    minutes: "m",
    hours: "h",
    day: "d",
    ago: "atr\xE1s",
    today: "hoje",
    tomorrow: "amanh\xE3"
  },
  months: {
    january: "Janeiro",
    february: "Fevereiro",
    march: "Mar\xE7o",
    april: "Abril",
    may: "Maio",
    june: "Junho",
    july: "Julho",
    august: "Agosto",
    september: "Setembro",
    october: "Outubro",
    november: "Novembro",
    december: "Dezembro"
  },
  monthsAbbrev: {
    january: "Jan",
    february: "Fev",
    march: "Mar",
    april: "Abr",
    may: "Mai",
    june: "Jun",
    july: "Jul",
    august: "Ago",
    september: "Set",
    october: "Out",
    november: "Nov",
    december: "Dez"
  }
};
const ptPTS1Ui = {
  aboutThis: {
    learnMore: "Aprender mais sobre",
    privacyPolicy: "Pol\xEDtica de Privacidade",
    termsAndConditions: "Termos e Condi\xE7\xF5es",
    version: "Vers\xE3o"
  },
  accountSwitcher: {
    production: "Produ\xE7\xE3o",
    test: "Teste"
  },
  attachmentsTab: {
    label: "Anexos"
  },
  attachmentsListTab: {
    emptyListLabel: "Ainda n\xE3o existem anexos",
    primaryButtonLabel: "Adicionar anexos"
  },
  autocomplete: {
    helpMessageTemplate: "Caracteres necess\xE1rios para pesquisa",
    loadingMessage: "Pesquisando"
  },
  avatar: {
    noName: "N\xE3o atribu\xEDdo"
  },
  commentsTab: {
    label: "Coment\xE1rios"
  },
  closeButton: {
    toolTip: "Fechar Painel"
  },
  columnDrawer: {
    addTooltipText: "Mostrar coluna",
    header: "Arraste e solte para reorganizar colunas",
    removeTooltipText: "Ocultar coluna",
    removeDisabledTooltipText: "Voc\xEA deve exibir pelo menos 1 coluna",
    title: "Colunas"
  },
  commentForm: {
    attachmentButtonTooltipText: "Adicionar anexo",
    commentPlaceholder: "Digite para deixar um coment\xE1rio.",
    errorEmpty: "O coment\xE1rio est\xE1 vazio.",
    errorLength: "O coment\xE1rio deve ter menos de 500 caracteres.",
    submitButton: "Coment\xE1rio"
  },
  commentsListTab: {
    emptyListLabel: "Nenhum coment\xE1rio ainda...",
    showLessLabel: "Mostrar menos coment\xE1rios",
    showMoreLabel: "Mostrar mais coment\xE1rios",
    tabPropsLabel: "Coment\xE1rios"
  },
  confirmationDialog: {
    "palavra-passeTitle": "Tem certeza?",
    "palavra-passeContent": "Uma confirma\xE7\xE3o positiva, como Transmitir, deve ter 2 bot\xF5es: Cancelar (Bot\xE3o secund\xE1rio) e 'A\xE7\xE3o Positiva' (Bot\xE3o Prim\xE1rio). Uma confirma\xE7\xE3o negativa, como Excluir, deve ter 2 a\xE7\xF5es, Cancelar (bot\xE3o prim\xE1rio) e 'A\xE7\xE3o Negativa' em um bot\xE3o vermelho."
  },
  customThemePage: {
    chooseTitle: "Escolha o seu tema",
    clearLogoTooltip: "Limpar URL do logotipo",
    colorPickerAriaLabel: "Seletor de Cores",
    customizeTitle: "Personalizar",
    "palavra-passeContentText": "Deseja substituir o tema personalizado pelas cores selecionadas?",
    "palavra-passeTitleText": "Substituir cores personalizadas",
    "palavra-passeLabels": {
      logoDescription: {
        recommended: "Formatos de arquivo recomendados: arquivo .svg, .webp ou .png com fundo transparente.",
        note: "Observa\xE7\xE3o: o arquivo carregado ser\xE1 dimensionado proporcionalmente para uma altura de 22 pixels. O novo logotipo aparecer\xE1 imediatamente na navega\xE7\xE3o.",
        warning: "Para usar o logotipo SOVOS padr\xE3o, remova o arquivo carregado."
      },
      logoAltLabel: "Texto alternativo do logotipo",
      logoAltHelptext: "O texto alternativo para logotipo personalizado \xE9 necess\xE1rio para acessibilidade",
      chooseTitle: "Escolha o seu tema",
      chooseDescription: "Escolha um tema. Pode personaliz\xE1-lo na pr\xF3xima etapa.",
      customizeTitle: "Personalizar",
      customizeDescription: "Ajuste a sua paleta de cores.",
      customSubtitles: {
        highlights: "Acentos e destaques do menu.",
        gradientBottom: "Gradiente inferior do plano de fundo do menu.",
        gradientTop: "Gradiente superior do plano de fundo do menu.",
        productIconColor: "Fundo do chaveador de produto",
        textColor: "Texto que aparece no menu."
      }
    },
    logoHelptext: "Protocolo e dom\xEDnio de n\xEDvel superior s\xE3o obrigat\xF3rios: (https://, .com)",
    logoLabel: "Logo da URL",
    logoTitle: "Adicionar um logotipo",
    themeSelectorTitle: "Selecione o tema {{title}}"
  },
  datePicker: {
    ariaLabel: "Alterar data",
    format: "MM/dd/yyyy",
    invalidDateMessage: "Formato de data inv\xE1lido",
    maxDateMessage: "A data n\xE3o deve ser definida ap\xF3s a data m\xE1xima",
    minDateMessage: "A data n\xE3o deve ser definida antes da data m\xEDnima"
  },
  dialogTitle: {
    closeDialogTooltip: "Fechar Di\xE1logo"
  },
  editableSlidingPanel: {
    closeDialogPropsTitle: "Mudan\xE7as n\xE3o salvas",
    closeDialogPropsContent: "Tem altera\xE7\xF5es n\xE3o salvas que ser\xE3o perdidas se fechar este painel. Deseja continuar a editar?"
  },
  errorPageCodes: {
    "400": {
      actionLink: "Ir para a p\xE1gina inicial",
      description: "N\xE3o entendemos esta requisi\xE7\xE3o",
      header: "Requisi\xE7\xE3o incorreta"
    },
    "401": {
      actionLink: "Iniciar sess\xE3o.",
      description: "N\xE3o tem permiss\xE3o para visualizar esta p\xE1gina. Fa\xE7a login na sua conta e, se isso n\xE3o funcionar, entre em contato com o seu administrador.",
      header: "N\xE3o autorizado"
    },
    "403": {
      actionLink: "Ir para a p\xE1gina inicial",
      description: "N\xE3o tem permiss\xE3o para visualizar esta p\xE1gina. Entre em contato com o seu administrador para obter acesso.",
      header: "Proibido"
    },
    "404": {
      actionLink: "Ir para a p\xE1gina inicial",
      description: "N\xE3o foi poss\xEDvel encontrar esta p\xE1gina. O que procura foi movido, exclu\xEDdo ou o link pode estar quebrado.",
      header: "P\xE1gina n\xE3o encontrada"
    },
    "408": {
      actionLink: "Atualizar a p\xE1gina",
      description: "O servidor est\xE1 demorando muito para responder. Verifique se est\xE1 conectado \xE0 Internet e tente atualizar a p\xE1gina.",
      header: "Tempo limite para pedido"
    },
    "500": {
      actionLink: "Ir para a p\xE1gina inicial",
      description: "Algo n\xE3o est\xE1 a funcionar do nosso lado, mas \xE9 tempor\xE1rio. Atualize esta p\xE1gina ou volte um pouco mais tarde.",
      header: "Erro interno do servidor"
    },
    "501": {
      actionLink: "Ir para a p\xE1gina inicial",
      description: "N\xE3o foi poss\xEDvel exibir este conte\xFAdo. Atualize a p\xE1gina ou tente novamente na p\xE1gina inicial.",
      header: "N\xE3o implementado"
    },
    "502": {
      actionLink: "Ir para a p\xE1gina inicial",
      description: "Algo n\xE3o est\xE1 a funcionar do nosso lado, mas \xE9 tempor\xE1rio. Atualize esta p\xE1gina ou volte um pouco mais tarde.",
      header: "Servi\xE7o temporariamente sobrecarregado",
      statusLink: "Pode tamb\xE9m verificar {{ status.sovos.com }} para atualiza\xE7\xF5es."
    },
    "503": {
      actionLink: "Ir para a p\xE1gina inicial",
      description: "Algo n\xE3o est\xE1 a funcionar do nosso lado, mas \xE9 tempor\xE1rio. Atualize esta p\xE1gina ou volte um pouco mais tarde.",
      header: "Servi\xE7o n\xE3o dispon\xEDvel",
      statusLink: "Pode tamb\xE9m verificar {{ status.sovos.com }} para atualiza\xE7\xF5es."
    }
  },
  file: {
    confirmDelete: "Eliminar Arquivo",
    confirmDeleteContent: "Tem certeza de que deseja eliminar este arquivo?"
  },
  fileUpload: {
    attemptDuplicatedFile: "Tentativa de fazer upload de arquivo duplicado",
    button: "Procurar",
    changeAction: "Mudar arquivo",
    deleteAction: "Eliminar arquivo",
    dragActive: "Solte aqui para carregar",
    heading: "Carregar novo arquivo",
    help: "Arraste e solte ou procure",
    ariaLabel: "Carregar Arquivo",
    rejectedMessage: "Incapaz de fazer upload deste arquivo.",
    rejectedMessageDuplicated: "Arquivo duplicado",
    rejectedMessageType: "Tipos de arquivos suportados:",
    rejectedMessageSize: "O arquivo n\xE3o pode exceder"
  },
  filterDateRange: {
    format: "MM/dd/yyyy",
    fromLabel: "Data de in\xEDcio",
    invalidStartDate: "Data de in\xEDcio tem valor inv\xE1lido",
    invalidEndDate: "Data final tem valor inv\xE1lido",
    endDateAfterStartDate: "A data final deve ser posterior \xE0 data inicial",
    toLabel: "Data final"
  },
  filterDrawer: {
    title: "Filtros"
  },
  filterNumberRange: {
    fromLabel: "Valor inicial",
    startValueLessThanEndValue: "O valor final deve ser menor do que o valor inicial",
    toLabel: "Valor final",
    validationErrorMessage: "Valor inv\xE1lido"
  },
  group: {
    loading: "Carregando dados"
  },
  historyTab: {
    emptyListLabel: "Nenhum evento ainda...",
    label: "Hist\xF3rico",
    showMoreLabel: "Mostrar Mais",
    showLessLabel: "Mostrar Menos"
  },
  iconAvatar: {
    tooltip: "Sistema"
  },
  loginFlowForm: {
    errorMessage: "Algo correu mal. Tente novamente."
  },
  loginPage: {
    emptyPasswordError: "A senha n\xE3o pode estar vazia",
    emptyUsernameError: "O endere\xE7o de email n\xE3o pode estar vazio",
    forgotPassword: "Esqueci a senha",
    header: "Bem-vindo de volta!",
    invalidUsernameError: "Email inv\xE1lido",
    login: "Iniciar sess\xE3o",
    passwordPlaceholder: "Senha",
    subtitle: "Insira o seu endere\xE7o de email e senha para visualizar a sua conta",
    usernamePlaceholder: "Endere\xE7o de email",
    errorMessage: "Desculpe, combina\xE7\xE3o de login inv\xE1lida. Para obter assist\xEAncia, entre em contato com o administrador do sistema ou com o suporte t\xE9cnico."
  },
  monthRangePicker: {
    "palavra-passe": "In\xEDcio - Fim"
  },
  monthSelector: {
    specificMonthTooltip: "Ir para um m\xEAs espec\xEDfico",
    previousMonthTooltip: "M\xEAs anterior",
    nextMonthTooltip: "Pr\xF3ximo m\xEAs",
    thisMonth: "Este m\xEAs"
  },
  minimizedNavigation: {
    ariaLabel: "Abrir Navega\xE7\xE3o"
  },
  navigation: {
    baseError: "'SovosNavigation' recebeu um link inv\xE1lido: os links devem ter nestedLinks ou uma fun\xE7\xE3o de a\xE7\xE3o, mas foi recebido",
    productSwitcherLabel: "Seletor de produto"
  },
  navigationLinks: {
    showSubnavigationTooltip: "Mostrar Subnavega\xE7\xE3o",
    hideSubnavigationTooltip: "Ocultar Subnavega\xE7\xE3o"
  },
  navigationFooter: {
    collapse: "Colapsar",
    expand: "Expandir",
    ajuda: "Ajuda"
  },
  noResultsLabels: {
    helpLabel: "Tente ajustar sua pesquisa ou filtre suas op\xE7\xF5es para encontrar o que procura",
    headingLabelData: "Nenhum dado para exibir",
    helpLabelData: "Nenhum dado dispon\xEDvel neste momento para ser exibido"
  },
  orderableList: {
    addTooltip: "Adicionar Item",
    header: "Arraste e solte para modificar a ordem",
    removeDisabledTooltipText: "N\xE3o existem mais itens para remover",
    removeTooltip: "Remover Item"
  },
  paginationFooter: {
    itemsPerPage: "mostrar",
    nextPage: "P\xE1gina seguinte",
    previousPage: "P\xE1gina anterior",
    results: "resultados"
  },
  readOnlyDrawer: {
    closeDrawerTooltip: "Fechar Gaveta"
  },
  resetPasswordStartPage: {
    back: "Voltar para iniciar sess\xE3o",
    emailPlaceholder: "Email",
    emptyEmailError: "O endere\xE7o de email n\xE3o deve ficar vazio",
    header: "Criar nova senha",
    invalidEmailError: "Email inv\xE1lido",
    next: "Pr\xF3ximo",
    subtitle: "Inserir endere\xE7o de email associado \xE0 sua conta.",
    subtitle2: "Se coincidir com uma conta ativa, enviaremos um email com instru\xE7\xF5es sobre como criar uma nova senha."
  },
  resetPasswordSuccessPage: {
    header: "Senha atualizada!",
    next: "Voltar para iniciar sess\xE3o",
    subtitle: "Sua senha foi atualizada com sucesso. Por favor, use sua nova senha e nome de utilizador para iniciar sess\xE3o na Sovos."
  },
  resetPasswordUpdatePage: {
    errorMessage: "J\xE1 utilizou esta senha anteriormente. Por favor, tente uma nova senha",
    header: "Criar nova senha",
    newPasswordHelperText: "Deve conter, pelo menos, 8 caracteres, incluindo, no m\xEDnimo, 1 letra mai\xFAscula, 1 n\xFAmero e 1 caractere especial (!,@,#,$,%,&,*)",
    newPasswordPlaceholder: "Nova senha",
    next: "Criar nova senha",
    passwordConfirmationError: "As senhas n\xE3o coincidem",
    passwordConfirmationPlaceholder: "Confirmar senha",
    subtitle: "Por favor, crie uma nova senha. A nova senha n\xE3o deve ser igual \xE0 sua hist\xF3ria de senhas."
  },
  resetPasswordVerificationPage: {
    errorMessage: "O c\xF3digo de recupera\xE7\xE3o que inseriu j\xE1 n\xE3o \xE9 v\xE1lido",
    emptyRecoveryCodeError: "O c\xF3digo de recupera\xE7\xE3o n\xE3o pode estar vazio",
    header: "Verificar c\xF3digo de recupera\xE7\xE3o",
    recoveryCodePlaceholder: "C\xF3digo de recupera\xE7\xE3o",
    next: "Pr\xF3ximo",
    subtitle: "Inserir o c\xF3digo de recupera\xE7\xE3o enviado por email.",
    subtitle2: "Por favor, n\xE3o saia desta p\xE1gina."
  },
  table: {
    totals: "Totais"
  },
  toolbar: {
    columnDrawerTooltip: "Mostrar/Ocultar Colunas",
    density: "Densidade",
    filtros: "Filtros",
    refresh: "Atualizar"
  },
  toolbarDataGrouping: {
    emptyGroupings: "Grupo de dados",
    editButton: "Editar agrupamentos",
    orderableListAddTooltip: "Adicionar grupo",
    orderableListHeader: "Arraste e solte para modificar a ordem dos seus grupos de dados",
    orderableListremoveTooltip: "Remover grupo",
    drawer: {
      title: "Grupos de dados",
      help: "Arraste e solte para modificar a ordem dos seus grupos de dados",
      addButton: "Adicionar grupo de dados",
      searchPlaceHolder: "Pesquisar por dados em grupo"
    },
    item: {
      activeGroup: "Todos",
      inactiveGroup: "Selecione uma linha"
    }
  },
  toolbarDateSelector: {
    endDateAfterStartDateMessage: "A data final deve ser posterior \xE0 data inicial",
    format: "MM/dd/yyyy",
    fromLabel: "Data de in\xEDcio",
    invalidEndDateMessage: "A data final tem um valor inv\xE1lido",
    invalidStartDateMessage: "A data de in\xEDcio tem um valor inv\xE1lido",
    toLabel: "Data final"
  },
  toolbarBulkActions: {
    selected: "selecionado"
  },
  toolbarColumn: {
    tooltip: "Editar colunas"
  },
  toolbarFilter: {
    tooltip: "Filtros"
  }
};
const frCommon = {
  add: "Ajouter",
  apply: "Appliquer",
  cancel: "Annuler",
  clear: "Effacer",
  open: "Ouvrir",
  close: "Fermer",
  "delete": "Supprimer",
  download: "T\xE9l\xE9charger",
  downloadAll: "Tout t\xE9l\xE9charger",
  endDate: "Date de fin",
  endValue: "Valeur finale",
  more: "Plus",
  noResults: "Aucun r\xE9sultat trouv\xE9",
  reset: "R\xE9initialisation",
  save: "Sauvegarder",
  search: "Rechercher",
  settings: "Param\xE8tres",
  showLess: "Afficher moins",
  showMore: "Afficher plus",
  startDate: "Date de d\xE9but",
  startValue: "Valeur initiale",
  yourAccount: "Votre compte",
  actions: {
    audit: "Audit",
    "continue": "Continuer",
    clear: "Effacer",
    create: "Cr\xE9er",
    edit: "Modifier",
    file: "Fichier",
    "import": "Importer",
    "new": "Nouveau",
    remove: "Supprimer",
    done: "Termin\xE9"
  },
  commonWords: {
    assignee: "Responsable",
    company: "Entreprise",
    country: "Pays",
    customer: "Client",
    deadline: "Date limite",
    no: "Non",
    only: "Uniquement",
    or: "ou",
    "return": "Retour",
    required: "Requis",
    saved: "Sauvegard\xE9",
    task: "T\xE2che",
    vendor: "Vendeur",
    yes: "Oui"
  },
  friendlyTimestamp: {
    seconds: "s",
    minutes: "m",
    hours: "h",
    day: "j",
    ago: "il y a",
    today: "aujourd'hui",
    tomorrow: "demain"
  },
  months: {
    january: "Janvier",
    february: "F\xE9vrier",
    march: "Mars",
    april: "Avril",
    may: "Mai",
    june: "Juin",
    july: "Juillet",
    august: "Ao\xFBt",
    september: "Septembre",
    october: "Octobre",
    november: "Novembre",
    december: "D\xE9cembre"
  },
  monthsAbbrev: {
    january: "Janv.",
    february: "F\xE9v.",
    march: "Mar",
    april: "Avr.",
    may: "Mai",
    june: "Juin",
    july: "Juil.",
    august: "Ao\xFBt",
    september: "Sept.",
    october: "Oct.",
    november: "Nov.",
    december: "D\xE9c."
  }
};
const frS1Ui = {
  aboutThis: {
    learnMore: "En savoir plus sur",
    privacyPolicy: "Politique de Confidentialit\xE9",
    termsAndConditions: "Termes et Conditions",
    version: "Version"
  },
  accountSwitcher: {
    production: "Production",
    test: "Test"
  },
  attachmentsTab: {
    label: "Pi\xE8ces jointes"
  },
  attachmentsListTab: {
    emptyListLabel: "Pas encore de pi\xE8ces jointes",
    primaryButtonLabel: "Ajouter une pi\xE8ce jointe"
  },
  autocomplete: {
    helpMessageTemplate: "caract\xE8res n\xE9cessaires pour la recherche",
    loadingMessage: "Recherche"
  },
  avatar: {
    noName: "Non assign\xE9"
  },
  commentsTab: {
    label: "Commentaires"
  },
  closeButton: {
    toolTip: "Fermer le panneau"
  },
  columnDrawer: {
    addTooltipText: "Afficher la colonne",
    header: "Glissez-d\xE9posez pour modifier l'ordre des colonnes",
    removeTooltipText: "Masquer la colonne",
    removeDisabledTooltipText: "Vous devez afficher au moins une colonne",
    title: "Colonnes"
  },
  commentForm: {
    attachmentButtonTooltipText: "Ajouter une pi\xE8ce jointe",
    commentPlaceholder: "Commencez \xE0 taper pour laisser un commentaire...",
    errorEmpty: "Le commentaire est vide.",
    errorLength: "Le commentaire doit contenir moins de 500 caract\xE8res.",
    submitButton: "Commentaire"
  },
  commentsListTab: {
    emptyListLabel: "Aucun commentaire pour le moment...",
    showLessLabel: "Afficher moins de commentaires",
    showMoreLabel: "Afficher plus de commentaires",
    tabPropsLabel: "Commentaires"
  },
  confirmationDialog: {
    defaultTitle: "\xCAtes-vous s\xFBr?",
    defaultContent: "Une confirmation positive, comme Transmettre, devrait avoir 2 boutons : Annuler (bouton secondaire) et 'Action positive' (bouton principal). Une confirmation n\xE9gative, comme Supprimer, devrait avoir 2 actions : Annuler (bouton principal) et 'Action n\xE9gative' dans un bouton rouge."
  },
  customThemePage: {
    chooseTitle: "Choisissez votre th\xE8me",
    clearLogoTooltip: "Effacer l'URL du logo",
    colorPickerAriaLabel: "S\xE9lecteur de couleur",
    customizeTitle: "Personnaliser",
    customSubtitlesBackground: "Arri\xE8re-plan du menu.",
    customSubtitlesHighlights: "Accents et points forts du menu.",
    customSubtitlesHover: "Survoler les points forts des arri\xE8re-plans.",
    customSubtitlesText: "Texte apparaissant dans le menu.",
    defaultContentText: "Voulez-vous \xE9craser le th\xE8me personnalis\xE9 avec les couleurs s\xE9lectionn\xE9es ?",
    defaultLabels: {
      logoDescription: {
        recommended: "Formats de fichiers recommand\xE9s : fichier .svg, .webp ou .png avec un fond transparent.",
        note: "Note : Le fichier t\xE9l\xE9charg\xE9 sera mis \xE0 l'\xE9chelle proportionnellement pour avoir une hauteur de 22 pixels. Le nouveau logo appara\xEEtra imm\xE9diatement dans la navigation.",
        warning: "Pour utiliser le logo SOVOS par d\xE9faut, supprimez le fichier t\xE9l\xE9charg\xE9."
      },
      logoAltLabel: "Texte alt du logo",
      logoAltHelptext: "Le texte alt pour le logo personnalis\xE9 est requis pour l'accessibilit\xE9",
      chooseTitle: "Choisissez votre th\xE8me",
      chooseDescription: "Choisissez un th\xE8me. Vous pouvez le personnaliser \xE0 l'\xE9tape suivante.",
      customizeTitle: "Personnaliser",
      customizeDescription: "Affinez votre palette de couleurs.",
      customSubtitles: {
        background: "Arri\xE8re-plan du menu.",
        highlights: "Accents et points forts du menu.",
        hover: "Survoler les points forts des arri\xE8re-plans.",
        productIconColor: "Arri\xE8re-plan du \xE9lecteur de produit",
        textColor: "Texte apparaissant dans le menu."
      }
    },
    defaultTitleText: "\xC9craser les couleurs personnalis\xE9es",
    logoHelptext: "Le protocole et le domaine de premier niveau sont requis. (https://, .com)",
    logoLabel: "URL du logo",
    logoTitle: "Ajouter un logo",
    themeSelectorTitle: "S\xE9lectionner le th\xE8me {{titre}}"
  },
  datePicker: {
    ariaLabel: "Changer la date",
    format: "MM/dd/yyyy",
    invalidDateMessage: "Format de date invalide",
    maxDateMessage: "La date ne doit pas \xEAtre post\xE9rieure \xE0 la date maximale",
    minDateMessage: "La date ne doit pas \xEAtre ant\xE9rieure \xE0 la date minimale"
  },
  dialogTitle: {
    closeDialogTooltip: "Fermer la fen\xEAtre de dialogue"
  },
  editableSlidingPanel: {
    closeDialogPropsTitle: "Modifications non sauvegard\xE9es",
    closeDialogPropsContent: "Vous avez des modifications non sauvagard\xE9es qui seront perdues si vous fermez ce panneau. Souhaitez-vous continuer \xE0 modifier ?",
    closeDialogPropsOKButtonProps: "Rejeter",
    closeDialogPropsCancelButtonProps: "Continuer \xE0 modifier"
  },
  errorPageCodes: {
    "400": {
      action: "Essayez de naviguer \xE0 partir de la page d'accueil.",
      actionLink: "Retourner \xE0 la page d'accueil",
      description: "D\xE9sol\xE9, la page ne fonctionne pas pour le moment.",
      header: "Mauvaise demande"
    },
    "401": {
      action: "Essayez de vous connecter.",
      actionLink: "Retour \xE0 la page de connexion",
      description: "D\xE9sol\xE9, vous n'avez pas acc\xE9s \xE0 cette page.",
      header: "Non autoris\xE9"
    },
    "403": {
      action: "Essayez d'actualiser cette page ou naviguez \xE0 partir de la page d'accueil.",
      actionLink: "Retourner \xE0 la page d'accueil",
      description: "Oups ! Nous ne trouvons pas cette page...",
      header: "Interdit"
    },
    "404": {
      action: "Essayez d'actualiser cette page ou naviguez \xE0 partir de la page d'accueil.",
      actionLink: "Retourner \xE0 la page d'accueil",
      description: "Oups ! Nous ne trouvons pas cette page...",
      header: "Page non trouv\xE9e"
    },
    "408": {
      action: "Essayez d'actualiser cette page plus tard ou naviguez \xE0 partir de la page d'accueil.",
      actionLink: "Retourner \xE0 la page d'accueil",
      description: "D\xE9sol\xE9, votre navigateur n'a pas envoy\xE9 une demande compl\xE8te \xE0 temps",
      header: "Le d\xE9lai de la demande est expir\xE9."
    },
    "500": {
      action: "Essayez d'actualiser cette page ou naviguez \xE0 partir de la page d'accueil.",
      actionLink: "Retourner \xE0 la page d'accueil",
      description: "D\xE9sol\xE9, le serveur ne reconna\xEEt pas la m\xE9thode de demande ou n'a pas la capacit\xE9 de r\xE9pondre \xE0 la demande.",
      header: "Non impl\xE9ment\xE9"
    },
    "502": {
      action: "Essayez d'actualiser cette page plus tard ou naviguez \xE0 partir de la page d'accueil dans 30 secondes.",
      actionLink: "Retourner \xE0 la page d'accueil",
      description: "D\xE9sol\xE9, le serveur a rencontr\xE9 une erreur temporaire et n'a pas pu traiter votre demande.",
      header: "Service temporairement surcharg\xE9"
    },
    "503": {
      action: "Essayez d'actualiser cette page plus tard ou naviguez \xE0 partir de la page d'accueil dans 30 secondes.",
      actionLink: "Retourner \xE0 la page d'accueil",
      description: "D\xE9sol\xE9, le serveur a rencontr\xE9 une erreur temporaire et n'a pas pu traiter votre demande.",
      header: "Service indisponible"
    },
    helpLinkTitle: "Portail de support",
    helpLinkText: "Voir les articles, vid\xE9os et contacter le support"
  },
  file: {
    confirmDelete: "Supprimer le fichier",
    confirmDeleteContent: "\xCAtes-vous s\xFBr de vouloir supprimer ce fichier?"
  },
  fileUpload: {
    attemptDuplicatedFile: "Tentative de t\xE9l\xE9chargement d'un fichier en double",
    button: "Parcourir",
    changeAction: "Modifier le fichier",
    deleteAction: "Supprimer le fichier",
    dragActive: "Glissez-d\xE9posez pour t\xE9l\xE9charger",
    heading: "T\xE9l\xE9charger un nouveau fichier",
    help: "Glisser-d\xE9poser ou parcourir",
    ariaLabel: "T\xE9l\xE9chargement de fichier",
    rejectedMessage: "Impossible de t\xE9l\xE9charger le fichier.",
    rejectedMessageDuplicated: "Fichier en double",
    rejectedMessageType: "Types de fichiers pris en charge :",
    rejectedMessageSize: "Le fichier ne peut pas d\xE9passer"
  },
  filterDateRange: {
    format: "MM/dd/yyyy",
    fromLabel: "Date de d\xE9but",
    toLabel: "Date de fin",
    invalidStartDate: "La date de d\xE9but a une valeur invalide",
    invalidEndDate: "La date de fin a une valeur invalide",
    endDateAfterStartDate: "La date de fin doit \xEAtre post\xE9rieure \xE0 la date de d\xE9but"
  },
  filterDrawer: {
    title: "Filtres"
  },
  filterNumberRange: {
    fromLabel: "Valeur initiale",
    startValueLessThanEndValue: "La valeur initiale doit \xEAtre inf\xE9rieure \xE0 la valeur finale",
    toLabel: "Valeur finale",
    validationErrorMessage: "Valeur invalide"
  },
  group: {
    loading: "Chargement des donn\xE9es"
  },
  historyTab: {
    emptyListLabel: "Aucun \xE9v\xE9nement pour le moment...",
    showLessLabel: "Afficher moins d'\xE9v\xE9nements",
    showMoreLabel: "Afficher plus d'\xE9v\xE9nements",
    label: "Historique"
  },
  iconAvatar: {
    tooltip: "Syst\xE8me"
  },
  loginFlowForm: {
    errorMessage: "Quelque chose s'est mal pass\xE9. Veuillez r\xE9essayer."
  },
  loginPage: {
    emptyPasswordError: "Le mot de passe ne peut pas \xEAtre vide",
    emptyUsernameError: "L'adresse e-mail ne peut pas \xEAtre vide",
    forgotPassword: "Mot de passe oubli\xE9",
    header: "Bienvenue \xE0 nouveau !",
    invalidUsernameError: "Adresse e-mail invalide",
    login: "Connexion",
    passwordPlaceholder: "Mot de passe",
    subtitle: "Entrez votre adresse e-mail et votre mot de passe pour acc\xE9der \xE0 votre compte.",
    usernamePlaceholder: "Adresse e-mail",
    errorMessage: "D\xE9sol\xE9, la combinaison d'identifiant et de mot de passe est invalide. Pour obtenir de l'aide, contactez votre administrateur syst\xE8me ou le support technique."
  },
  monthRangePicker: {
    "default": "D\xE9but - Fin"
  },
  monthSelector: {
    specificMonthTooltip: "Allez \xE0 un mois sp\xE9cifique.",
    previousMonthTooltip: "Mois Pr\xE9c\xE9dent",
    nextMonthTooltip: "Mois Prochain",
    thisMonth: "Ce mois-ci"
  },
  minimizedNavigation: {
    ariaLabel: "Navigation ouverte"
  },
  navigation: {
    baseError: "'SovosNavigation' a re\xE7u un lien invalide :les liens doivent avoir des nestedLinks ou une fonction d'action, mais a re\xE7u",
    productSwitcherLabel: "S\xE9lecteur de produit"
  },
  navigationLinks: {
    showSubnavigationTooltip: "Afficher la sous-navigation",
    hideSubnavigationTooltip: "Masquer la sous-navigation"
  },
  navigationFooter: {
    collapse: "R\xE9duire",
    expand: "\xC9tendre",
    help: "Aide"
  },
  noResultsLabels: {
    helpLabel: "Essayez d'ajuster vos options de recherche ou de filtre pour trouver ce que vous cherchez.",
    headingLabelData: "Pas de donn\xE9es \xE0 afficher.",
    helpLabelData: "Aucune donn\xE9e n'est actuellement disponible pour affichage."
  },
  orderableList: {
    addTooltip: "Ajouter un article",
    header: "Glisser-d\xE9poser pour modifier l'ordre",
    removeDisabledTooltipText: "Aucun autre article ne peut \xEAtre supprim\xE9",
    removeTooltip: "Supprimer un article"
  },
  paginationFooter: {
    itemsPerPage: "afficher",
    nextPage: "Page suivante",
    previousPage: "Page pr\xE9c\xE9dente",
    results: "r\xE9sultats"
  },
  readOnlyDrawer: {
    closeDrawerTooltip: "Refermer le tiroir"
  },
  resetPasswordStartPage: {
    back: "Retour \xE0 la connexion",
    emailPlaceholder: "E-mail",
    emptyEmailError: "L'adresse e-mail ne peut pas \xEAtre vide",
    header: "R\xE9initialiser le mot de passe",
    invalidEmailError: "E-mail invalide",
    next: "suivant",
    subtitle: "Entrez l'adresse e-mail associ\xE9e \xE0 votre compte",
    subtitle2: "S'il s'agit d'un compte actif, nous vous enverrons un e-mail avec des instructions pour r\xE9initialiser votre mot de passe."
  },
  resetPasswordSuccessPage: {
    header: "Mot de passe mis \xE0 jour !",
    next: "Retour \xE0 la connexion",
    subtitle: "Votre mot de passe a \xE9t\xE9 r\xE9initialis\xE9 avec succ\xE8s. Veuillez utiliser votre nouveau mot de passe et nom d'utilisateur pour vous connecter \xE0 Sovos."
  },
  resetPasswordUpdatePage: {
    errorMessage: "Vous avez d\xE9j\xE0 utilis\xE9 ce mot de passe, veuillez en essayer un autre",
    header: "R\xE9initialiser le mot de passe",
    newPasswordHelperText: "Doit contenir au moins 8 caract\xE8res, comprenant au moins 1 lettre majuscule, 1 chiffre et 1 caract\xE8re sp\xE9cial (!,@,#,$,%,&,*).",
    newPasswordPlaceholder: "Nouveau mot de passe",
    next: "R\xE9initialiser le mot de passe",
    passwordConfirmationError: "Les mots de passe ne correspondent pas",
    passwordConfirmationPlaceholder: "Confirmez le mot de passe",
    subtitle: "Veuillez cr\xE9er un nouveau mot de passe. Votre nouveau mot de passe ne peut pas \xEAtre identique \xE0 vos mots de passe pr\xE9c\xE9dents."
  },
  resetPasswordVerificationPage: {
    errorMessage: "Le code de r\xE9cup\xE9ration que vous avez saisi n'est plus valide.",
    emptyRecoveryCodeError: "Le code de r\xE9cup\xE9ration ne peut pas \xEAtre vide",
    header: "V\xE9rifier le code de r\xE9cup\xE9ration",
    recoveryCodePlaceholder: "Code de r\xE9cup\xE9ration",
    next: "Suivant",
    subtitle: "Entrez le code de r\xE9cup\xE9ration envoy\xE9 sur votre e-mail.",
    subtitle2: "Ne quittez pas cette page, s'il vous pla\xEEt."
  },
  table: {
    totals: "Totaux"
  },
  toolbar: {
    columnDrawerTooltip: "Afficher/Masquer la colonne",
    density: "Densit\xE9",
    filters: "Filtres",
    refresh: "Actualiser"
  },
  toolbarDataGrouping: {
    emptyGroupings: "Regrouper les donn\xE9es",
    editButton: "Modifier les regroupements",
    orderableListAddTooltip: "Ajouter un groupe",
    orderableListHeader: "Glissez-d\xE9posez pour modifier l'ordre de vos groupes de donn\xE9es",
    orderableListremoveTooltip: "Supprimer le groupe",
    drawer: {
      title: "Groupes de donn\xE9es",
      help: "Glissez-d\xE9posez pour modifier l'ordre des groupes de donn\xE9es",
      addButton: "Ajouter un groupe de donn\xE9es",
      searchPlaceHolder: "Recherche d'un groupe de donn\xE9es"
    },
    item: {
      activeGroup: "Tous",
      inactiveGroup: "S\xE9lectionner une ligne"
    }
  },
  toolbarDateSelector: {
    endDateAfterStartDateMessage: "La date de fin doit \xEAtre post\xE9rieure \xE0 la date de d\xE9but",
    format: "MM,jj,aaaa",
    fromLabel: "Date de d\xE9but",
    invalidEndDateMessage: "La date de fin a une valeur invalide",
    invalidStartDateMessage: "La date de d\xE9but a une valeur invalide",
    toLabel: "Date de fin"
  },
  toolbarBulkActions: {
    selected: "selectionn\xE9"
  },
  toolbarColumn: {
    tooltip: "Modifier les colonnes"
  },
  toolbarFilter: {
    tooltip: "Filtres"
  }
};
const {
  branding,
  emptyStates,
  heroBanners,
  locales
} = assetKeys;
const localesEn = {
  ...enUSCommon,
  ...enUSs1ui
};
const localesEs = {
  ...esCommon,
  ...esS1Ui
};
const localesPtBR = {
  ...ptBRCommon,
  ...ptBRS1Ui
};
const localesPtPT = {
  ...ptPTCommon,
  ptPTS1Ui
};
const localesFr = {
  ...frCommon,
  ...frS1Ui
};
export default {
  branding: {
    [branding.iconLarge]: iconLarge,
    [branding.logoLight]: logoLightSvg,
    [branding.logoDark]: logoDarkSvg
  },
  emptyStates: {
    [emptyStates.noDataAvailable]: noDataAvailableSvg,
    [emptyStates.noSearchResults]: noSearchResultsSvg,
    [emptyStates.noTasksAvailable]: noTasksAvailableSvg
  },
  heroBanners: {
    [heroBanners.colors.dark]: heroDarkBgImg,
    [heroBanners.colors.default]: heroDefaultBgImg,
    [heroBanners.colors.error]: heroErrorBgImg,
    [heroBanners.colors.inProgress]: heroInProgressBgImg,
    [heroBanners.colors.success]: heroSuccessBgImg,
    [heroBanners.colors.warning]: heroWarningBgImg
  },
  locales: {
    [locales.en]: localesEn,
    [locales['en-US']]: localesEn,
    [locales.es]: localesEs,
    [locales['es-ES']]: localesEs,
    [locales.pt]: localesPtPT,
    [locales['pt-BR']]: localesPtBR,
    [locales['pt-PT']]: localesPtPT,
    [locales.fr]: localesFr,
    [locales['fr-FR']]: localesFr
  }
};